/* Fresca — How to use: accessible keyboard tabs, swipe between products, steps that light up as the progress line reaches them.
   Tab switching itself (aria-selected, hidden panels, ink) is handled by fresca.js [data-tabs]. */
(() => {
  const sections = document.querySelectorAll('.fr-how');
  if (!sections.length) return;

  sections.forEach((sec) => {
    const tabs = sec.querySelector('[data-tabs]');
    if (!tabs) return;
    const btns = [...tabs.querySelectorAll('[data-tab]')];
    const syncIndex = () => btns.forEach((b) => { b.tabIndex = b.getAttribute('aria-selected') === 'true' ? 0 : -1; });
    const current = () => Math.max(0, btns.findIndex((b) => b.getAttribute('aria-selected') === 'true'));
    const go = (i, focus) => {
      const b = btns[(i + btns.length) % btns.length];
      if (b.getAttribute('aria-selected') !== 'true') b.click();
      if (focus) b.focus();
    };
    syncIndex();

    btns.forEach((b, i) => {
      b.addEventListener('click', () => requestAnimationFrame(() => { syncIndex(); light(); }));
      b.addEventListener('keydown', (e) => {
        const map = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: btns.length - 1 };
        if (!(e.key in map)) return;
        e.preventDefault();
        go(map[e.key], true);
      });
    });

    // Horizontal swipe on the panel area switches product (touch only, never blocks vertical scroll)
    const area = sec.querySelector('[data-how-swipe]');
    if (area) {
      let x0 = null, y0 = 0, t0 = 0;
      area.addEventListener('touchstart', (e) => { const t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; t0 = Date.now(); }, { passive: true });
      area.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const t = e.changedTouches[0];
        const dx = t.clientX - x0, dy = t.clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 56 && Math.abs(dx) > Math.abs(dy) * 1.6 && Date.now() - t0 < 700) go(current() + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }
  });

  // Light each step icon once the scroll-linked progress line (fresca.js --line-p) has reached it
  const lists = [...document.querySelectorAll('.fr-how [data-steps]')];
  function light() {
    const vh = window.innerHeight;
    lists.forEach((list) => {
      if (list.closest('[hidden]')) return;
      const r = list.getBoundingClientRect();
      if (!r.height) return;
      const p = Math.min(1, Math.max(0, (vh * 0.75 - r.top) / r.height));
      const items = [...list.children];
      const first = items[0] && items[0].querySelector('.fr-step__icon');
      const last = items[items.length - 1] && items[items.length - 1].querySelector('.fr-step__icon');
      if (!first || !last) return;
      const c = (el) => { const b = el.getBoundingClientRect(); return b.top + b.height / 2; };
      const start = c(first), end = c(last);
      const reach = start + p * (end - start);
      items.forEach((li) => {
        const ic = li.querySelector('.fr-step__icon');
        li.classList.toggle('is-lit', p > 0 && !!ic && c(ic) <= reach + 2);
      });
    });
  }
  let queued = false;
  const onScroll = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; light(); }); };
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll);
  light();
})();
